import enviro from 'enviro';
import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
import { transformState } from 'pricing-pages-ui/selectors/SelectorUtils';

// parcelName:productId mapping that exists in both seats/non-seats in QA
const BASE_PARCEL_NAME_TO_PRODUCT_ID_QA = {
  'additional-brand-domains': 85,
  'additional-calling-minutes-1000': 81150,
  'additional-calling-purchased-phone-numbers-5': 81151,
  'additional-contacts-and-emails': 97,
  'additional-embeddable-videos': 65149,
  'additional-sandboxes': 64154,
  'additional-teams': 119,
  'additional-transcription-capacity': 33149,
  'additional-users': 122,
  'additional-whatsapp-conversations-1000': 126149,
  'additional-workflows': 129,
  ads: 91,
  'ads-add-on': 124,
  'api-addon-2016': 125,
  'cms-enterprise': 6,
  'cms-standalone-free': 116,
  'cms-standalone-paid': 17,
  'cms-starter': 44149,
  'contact-smart-lists-additional': 121,
  'content-custom-ssl': 59,
  'content-ssl': 9,
  'custom-object-capacity-pack': 130,
  'dedicated-ip-marketing': 32,
  'dedicated-ip-transactional': 42,
  'domain-limit-increase': 51151,
  'esign-capacity-pack': 131,
  'hubspot-free': 56,
  'marketing-basic': 97,
  'marketing-enterprise': 71,
  'marketing-enterprise-legacy-features': 143,
  'marketing-free-2016': 92,
  'marketing-pro': 100,
  'marketing-starter': 30,
  'ops-enterprise': 64149,
  'ops-pro': 148,
  'ops-starter': 147,
  reporting: 128,
  'sales-enterprise-bundle': 39,
  'sales-pro': 104,
  'sales-pro-bundle': 23,
  'sales-pro-legacy-limits': 145,
  'sales-starter-bundle': 61,
  'service-enterprise-bundle': 35,
  'service-free': 54,
  'service-professional-bundle': 79,
  'service-starter-bundle': 34,
  'unlimited-contacts-grandfathered': 31
};
const PARCEL_NAME_TO_PRODUCT_ID_QA = Object.assign({}, BASE_PARCEL_NAME_TO_PRODUCT_ID_QA, {
  'additional-marketing-contacts-enterprise': 71,
  'additional-marketing-contacts-pro': 100,
  'additional-marketing-contacts-starter': 30,
  'sales-enterprise-additional-seat': 39,
  'sales-pro-additional-seat': 23,
  'sales-starter-additional-seat': 61,
  'service-enterprise-additional-seat': 35,
  'service-professional-additional-seat': 79,
  'service-starter-additional-seat': 34
});
const SEATS_PARCEL_NAME_TO_PRODUCT_ID_QA = Object.assign({}, BASE_PARCEL_NAME_TO_PRODUCT_ID_QA, {
  'additional-marketing-contacts-enterprise-seatspricing': 71,
  'additional-marketing-contacts-pro-seatspricing': 100,
  'additional-marketing-contacts-starter-seatspricing': 30,
  'core-enterprise-seat': 130151,
  'core-pro-seat': 130150,
  'core-starter-seat': 130149,
  'included-core-starter-seat': 130152
});

// parcelName:productId mapping that exists in both seats/non-seats in Prod
const BASE_PARCEL_NAME_TO_PRODUCT_ID_PROD = {
  'additional-brand-domains': 85,
  'additional-calling-minutes-1000': 802146,
  'additional-calling-purchased-phone-numbers-5': 802147,
  'additional-contacts-and-emails': 97,
  'additional-embeddable-videos': 818147,
  'additional-sandboxes': 774147,
  'additional-teams': 120,
  'additional-transcription-capacity': 753148,
  'additional-users': 123,
  'additional-whatsapp-conversations-1000': 825146,
  'additional-workflows': 131,
  'ads-add-on': 126,
  'api-addon-2016': 127,
  'cms-enterprise': 6,
  'cms-standalone-free': 116,
  'cms-standalone-paid': 17,
  'cms-starter': 761148,
  'contact-smart-lists-additional': 122,
  'content-custom-ssl': 59,
  'content-ssl': 9,
  'custom-object-capacity-pack': 133,
  'dedicated-ip-marketing': 32,
  'dedicated-ip-transactional': 42,
  'domain-limit-increase': 761149,
  'esign-capacity-pack': 134,
  'hubspot-free': 56,
  'marketing-basic': 97,
  'marketing-enterprise': 71,
  'marketing-enterprise-legacy-features': 141,
  'marketing-free-2016': 132,
  'marketing-pro': 100,
  'marketing-starter': 30,
  'ops-enterprise': 774146,
  'ops-pro': 501147,
  'ops-starter': 501146,
  reporting: 130,
  'sales-enterprise-bundle': 39,
  'sales-pro-bundle': 23,
  'sales-pro-legacy-limits': 142,
  'sales-starter-bundle': 61,
  'service-enterprise-bundle': 35,
  'service-free': 54,
  'service-professional-bundle': 79,
  'service-starter-bundle': 34,
  'unlimited-contacts-grandfathered': 31
};
const PARCEL_NAME_TO_PRODUCT_ID_PROD = Object.assign({}, BASE_PARCEL_NAME_TO_PRODUCT_ID_PROD, {
  'additional-marketing-contacts-enterprise': 71,
  'additional-marketing-contacts-pro': 100,
  'additional-marketing-contacts-starter': 30,
  'sales-enterprise-additional-seat': 39,
  'sales-pro-additional-seat': 23,
  'sales-starter-additional-seat': 61,
  'service-enterprise-additional-seat': 35,
  'service-professional-additional-seat': 79,
  'service-starter-additional-seat': 34
});
const SEATS_PARCEL_NAME_TO_PRODUCT_ID_PROD = Object.assign({}, BASE_PARCEL_NAME_TO_PRODUCT_ID_PROD, {
  'additional-marketing-contacts-enterprise-seatspricing': 71,
  'additional-marketing-contacts-pro-seatspricing': 100,
  'additional-marketing-contacts-starter-seatspricing': 30,
  'core-enterprise-seat': 824149,
  'core-pro-seat': 824148,
  'core-starter-seat': 824147,
  'included-core-starter-seat': 824146
});
export const getParcelNameToProductId = state => {
  const isQA = enviro.isQa() || getIsQAProxy();
  const isUngatedForSeats = getIsUngatedForSeats(transformState(state));
  return isQA ? isUngatedForSeats ? SEATS_PARCEL_NAME_TO_PRODUCT_ID_QA : PARCEL_NAME_TO_PRODUCT_ID_QA : isUngatedForSeats ? SEATS_PARCEL_NAME_TO_PRODUCT_ID_PROD : PARCEL_NAME_TO_PRODUCT_ID_PROD;
};